<template>
    <b-row>
        <b-col sm="12">
            <b-form-group>
                <label for="company">Company</label>
                <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                    :plain="true"
                    :options="companies">
                </b-form-select>
                <div v-if="!companiesLoaded" >
                    <i class="fa fa-spin fa-spinner"></i>
                </div>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>

import LookupDataService from '@/services/lookup-data-service.js';

export default {
    name: 'CompanyAreaSelection',
    props: ['companyId', 'userAuthLevel'],
    emits: ['company-selected'],
    components: {
    },
    data () {
        return {
            companies: [],
            companiesLoaded: false,
            filterParams: {
                company_id: -1,
            },
            internalUserAuthLevel: this.userAuthLevel,
        }
    },
    watch: {
        'filterParams.company_id': function(val, oldVal) {
            
            this.$emit('company-selected', val);
        },
    },
    computed: {
        isMinimumSuperAdmin() {
            let returnVal = false;
            switch (this.$data.internalUserAuthLevel) {
                case 'Super Admin':
                case 'Read Only':
                    returnVal = true;
                    break;
                default:
                    returnVal = false;
            }
            
            return returnVal;
        },
        isMinimumCompanyUser() {
            let returnVal = false;
            switch (this.$data.internalUserAuthLevel) {
                case 'Super Admin':
                case 'Company Users':
                case 'Read Only':
                    returnVal = true;
                    break;
                default:
                    returnVal = false;
            }

            return returnVal;
        },
        isMinimumAreaUser() {
            let returnVal = false;
            switch (this.$data.internalUserAuthLevel) {
                case 'Super Admin':
                case 'Company Users':
                case 'Area Users':
                case 'Read Only':
                    returnVal = true;
                    break;
                default:
                    returnVal = false;
            }

            return returnVal;
        },
        isMinimumSiteUser() {
            let returnVal = false;
            switch (this.$data.internalUserAuthLevel) {
                case 'Super Admin':
                case 'Company Users':
                case 'Area Users':
                case 'Site Users':
                case 'Read Only':
                    returnVal = true;
                    break;
                default:
                    returnVal = false;
            }
            
            return returnVal;
        }
    },
    async created() {
        this.$data.companies = await LookupDataService.getCompaniesList();
        this.$data.filterParams.company_id = this.companyId;
        this.$data.companiesLoaded = true;
    }
}
</script>
